import React, { useState } from "react";
// import { render } from "react-dom";
import { Stack, TextField } from '@mui/material'
import Button from "@mui/material/Button";
import Header from "./Header";

const Calculater3 = () => {
  const [principal, setPrincipal] = useState();
  const [years, setYears] = useState();
  const [interest, setInterest] = useState();
  const [result, setResult] = useState();

  const calculate = () => {
    if(principal===0 || years===0 || interest===0)
    {
      alert("please put all inputs")
    }
   else{// A=p(1+(r/n))^(nt)
    const result = principal * Math.pow(1 + interest, years);
    setResult(result.toFixed(1));
   }
  };
  const handleonClick = (e) => {
    setResult(0);
    window.location.reload();
 
  }
  

  return (
    <>
      <Header/>
    <div className="body4">
  
        <div className="card2">
        <h1 className='heading_one'> Compound Interest Calculator</h1>
        <div className='total_amount_card'>
          {/* <div className='card_text '> */}
          <h3 className='total_amount_heading'>₹{result}</h3>
          <p className='total_amount_para'>Total Compound interest</p>
          {/* </div> */}
        </div> 
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "40vh",
          marginTop: "50px",
        marginleft: "50px",
        color:"black",
        }}
      >
        <form>
        <Stack spacing={2} direction="column">
          <TextField
            label="What is the principal?"
            variant="outlined"
            type="number"
            className="inp_area"
            onChange={(e) => setPrincipal(e.target.value)}
            sx={{
        width: 250
    }}
    InputProps={{ sx: { height: 40 } }}/>
          
          <TextField
            label="How many years?"
            variant="outlined"
            type="number"
            className="inp_area"
            onChange={(e) => setYears(e.target.value)}
          />
          <TextField
            label="Annual Interest rate?"
            variant="outlined"
            type="number"
            className="inp_area"
            onChange={(e) => setInterest(e.target.value / 100)}
          />
          </Stack>
          <br />
          <br />
          <Stack spacing={2} direction="column">
          <Button
            variant="contained"
            color="primary"
            
            onClick={() => {
              calculate();
            }}
          >
            Calculate
          </Button>
          <Button  onClick={handleonClick}     color="primary"   variant="contained"> Reset </Button>
          </Stack>
          <br />
          <br />
          {/* <TextField
            label="₹"
            variant="outlined"
            type="number"
            className="inp_area"/>{result} */}
            {/* <h3 className='total_amount_heading'>₹{result}</h3> */}
        </form>
      </div>
      </div>
      </div>
    </>
  );
};
export default Calculater3